import {Subject} from 'rxjs';
import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {AuthorizationService} from 'app/security/core/services/authorization.service';
import {SecurityService} from 'app/security/core/services/security.service';
import {
  EAuthorizationItemType,
  EAuthorizationPermissionStatus,
  EAuthorizationPermissionType
} from 'app/security/core/models/enum/security.enum';
import * as _ from 'lodash';
import {BzgModalService, BzgToastService} from 'bz-genome-angular';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'authorization-detail',
  templateUrl: 'authorization-detail.component.html',
  styleUrls: ['authorization-detail.component.scss']
})
export class BzAuthorizationDetailComponent implements OnChanges {

  @Input() detailData: IAuthorizationDetail;
  @Input() authorizationType: string;
  @Input() nodeId: string;
  @Input() detailName: string;
  @Input() parameters: {[key: number]: Array<IAuthorizationCondition>};
  @Output() onCancelChanges = new EventEmitter();

  public isLoadingData: boolean;
  public advanceOptionsData: Array<IAuthorizationCondition>;
  public selectedFilterOption: number;
  public enumAuthorizationItemType = EAuthorizationItemType;
  public showAddCondition = false;
  public dataPermissions: any[] = [];
  public selectedConditionsToAdd: {[key: string]: {[key: string]: IAuthorizationCondition}}  = {};
  public selectedConditions = {};
  public isMultipleSelectionEnabled = false;
  public selectedItemsLength = 0;

  public dataUsers: Array<{id: string, name: string, category: number; permissions: any; itemIcon: string}> = [];
  private _accessPermissions: number[] = [];
  private listTimeOut: any[] = [];
  initialDetailData: any;
  saveResponse$: Subject<boolean> = new Subject<boolean>();
  filterUserGroup: string;
  filterRole: string;
  filterStakeholder: string;

  constructor(private authServices: AuthorizationService,
              private _translateService: TranslateService,
              private _toastService: BzgToastService) {
    this.selectedConditionsToAdd[EAuthorizationItemType.UserGroup] = {};
    this.selectedConditionsToAdd[EAuthorizationItemType.Role] = {};
    this.selectedConditionsToAdd[EAuthorizationItemType.Stakeholder] = {};
  }

  ngOnChanges(changes: any) {
    this.selectedItemsLength = 0;
    this.isMultipleSelectionEnabled = false;
    this.selectedConditions = {};
    this.isLoadingData = true;
    this.showAddCondition = false;
    this.filterUserGroup = '';
    this.filterRole = '';
    this.filterStakeholder = '';
    if (this.detailData) { this.listTimeOut.push(setTimeout(() => this.showDataDetail(), 2000)); }
    this.initialDetailData = _.cloneDeep(this.detailData);
  }

  ngOnDestroy(): void {
    this.listTimeOut.forEach(timeOut => clearTimeout(timeOut));
  }

  showDataDetail() {
    this.dataUsers = [];

    _.forEach(this.detailData.Items, (each) => {
      let idParameter: string;
      let nameParameter: any;
      let enumCatergory: number;
      if (each.AuthorizationGroup !== null) {
        enumCatergory = EAuthorizationItemType.UserGroup;
        idParameter = each.AuthorizationGroup.Id;
        nameParameter = (_.find(
          this.parameters[EAuthorizationItemType.UserGroup],
          { id: each.AuthorizationGroup.Id }
        ) as IAuthorizationUserGroup).content.displayName;
      }
      if (each.AuthorizationRole !== null) {
        enumCatergory = EAuthorizationItemType.Role;
        let fields = (_.find(this.parameters[EAuthorizationItemType.Role], {
          id: each.AuthorizationRole.Id
        }) as IAuthorizationRole).content.fields;

        if(typeof(fields) === 'string') {
          fields = JSON.parse(fields);
        }

        idParameter = each.AuthorizationRole.Id;
        nameParameter = fields['F5EE3DBD-20D5-44A0-8F5D-AE93C9F655CD'] || fields['f5ee3dbd-20d5-44a0-8f5d-ae93c9f655cd'];
      }

      if (each.AuthorizationStakeholder !== null) {enumCatergory = EAuthorizationItemType.Stakeholder;
        idParameter = each.AuthorizationStakeholder.Id;
          let icontent = (_.find(
          this.parameters[EAuthorizationItemType.Stakeholder],
          { id: each.AuthorizationStakeholder.Id }
        ) as IAuthorizationStakeholder);
        if(!icontent){
          return;
        }
        nameParameter = icontent.content.displayName;
      }

      const permissionsUser: any = each.Permissions;
      const icon: string = this._getIcon(enumCatergory);

      this. dataUsers.push({
        id: idParameter, name: nameParameter, category: enumCatergory,
        permissions: permissionsUser, itemIcon: icon
      });
    });

    this. dataUsers = _.orderBy(this. dataUsers, ['name'], ['asc']);
    this.isLoadingData = false;
  }

  private _getIcon(category: number): string {
    this.selectedFilterOption = category;
    switch (category) {
      case EAuthorizationItemType.UserGroup:
        return 'icon-user-group';
      case EAuthorizationItemType.Role:
        return 'icon-star';
      case EAuthorizationItemType.Stakeholder:
        return 'icon-user';
    }
  }

  public getPermissions(itemId: any, event: boolean) {
    this.dataPermissions = [];

    event ? this.selectedConditions[itemId] = true : delete this.selectedConditions[itemId];

    const selectedConditionsIds = _.keys(this.selectedConditions);
    const item =
      selectedConditionsIds && selectedConditionsIds.length > 0
        ? this.dataUsers.find(
            element =>
              element.id ===
              selectedConditionsIds[selectedConditionsIds.length - 1]
          )
        : null;

    if(item) {
      if (item.permissions.length === 0) {
        item.permissions = [{ 'Type': 10, 'Access': 2 }];
      }

      _.forEach(item.permissions, (permission, key) => {
        const type = permission.Type;
        const typeString = this._getPermissionType(type);

        if (typeString !== 'Delete') {
          const access = permission.Access;

          this._accessPermissions[key] = permission.Access;

          this.dataPermissions.push({
            type,
            typeString,
            access,
            statusAllow: access === 1,
            statusDeny: access === 0
          });
        }
      });
    }

    this._setSelectedItemsLength();
  }

  private _getPermissionType(type: number): string {
    switch (type) {
      case EAuthorizationPermissionType.FullControl:
        return 'Full Control';
      case EAuthorizationPermissionType.ViewData:
        return 'View Data';
      case EAuthorizationPermissionType.NewCase:
        return 'New Case';
      case EAuthorizationPermissionType.Use:
        return 'Access';
      default:
        return EAuthorizationPermissionType[type];
    }
  }

  public showAdvanceOptions(type: number) {

    this.selectedFilterOption = type;
    switch (type) {
      case EAuthorizationItemType.UserGroup:
        this.advanceOptionsData = this._filterConditions(EAuthorizationItemType.UserGroup);
        this.advanceOptionsData.sort((a,b) => a.content.displayName.localeCompare(b.content.displayName));
        break;
      case EAuthorizationItemType.Role:
        this.advanceOptionsData = this._filterConditions(EAuthorizationItemType.Role);
        this.advanceOptionsData.sort((a,b) => {          
          return this.getDisplayName(a).localeCompare(this.getDisplayName(b));
        });
        break;
      case EAuthorizationItemType.Stakeholder:
        this.advanceOptionsData = this._filterConditions(EAuthorizationItemType.Stakeholder);
        this.advanceOptionsData.sort((a,b) => a.content.displayName.localeCompare(b.content.displayName));
        break;
    }
  }

  public getDisplayName(assignation) {
    if(typeof(assignation.content.fields) === 'string') {
      assignation.content.fields = JSON.parse(assignation.content.fields);
    }
    return assignation.content.fields['f5ee3dbd-20d5-44a0-8f5d-ae93c9f655cd'] || assignation.content.fields['F5EE3DBD-20D5-44A0-8F5D-AE93C9F655CD']
  }

  private _loadPermissions(): any {
    const permissions: any = [];

    switch (this.authorizationType) {
      case 'Analysis':
        permissions.push({ Type: 10, Access: 2 });
        break;
      case 'Applications': case 'Pages': case 'SOAServices': case 'RPACallback':
        permissions.push({ Type: 5, Access: 2 });
        break;
      case 'ParametricEntities': case 'Stakeholders':
        permissions.push({ Type: 0, Access: 2 }, { Type: 1, Access: 2 }, { Type: 4, Access: 2 }, { Type: 2, Access: 2 });
        break;
      case 'WfClass':
        permissions.push({ Type: 6, Access: 2 });
        break;
      case 'Policy': case 'Vocabulary':
        permissions.push({ Type: 0, Access: 2 }, { Type: 1, Access: 2 }, { Type: 4, Access: 2 });
        break;
      case 'QueryForms':
        permissions.push({ Type: 1, Access: 2 }, { Type: 8, Access: 2 }, { Type: 9, Access: 2 });
        break;
      case 'Manage':
        permissions.push({ Type: 7, Access: 2 });
        break;
    }

    return permissions;
  }

  changeStatus(permission: any, state: number) {
    permission.statusAllow = state === 1;
    permission.statusDeny = state === 0;
    if (this.authorizationType === 'ParametricEntities' || this.authorizationType === 'Policy' ||
      this.authorizationType === 'Stakeholders' || this.authorizationType === 'Vocabulary') {
      this._changeStatusControl(permission.type, state);
    }
    else {
      this._changeStatusNormal(permission.type, state);
    }

    this.showDataDetail();

  }

  private _changeStatusControl(type: any, state: number) {
    let states: number[] = this._accessPermissions;

    if (type !== EAuthorizationPermissionType.FullControl) {
      states[0] = EAuthorizationPermissionStatus.None;
    }
    switch (type) {
      case EAuthorizationPermissionType.FullControl:
        states = [state, state, state, state, state];
        break;
      case EAuthorizationPermissionType.ViewData:
        states[1] = state;
        if (states[2] === 1 && state === 0) { states[2] = EAuthorizationPermissionStatus.None; }
        if (states[3] === 1 && state === 0) { states[3] = EAuthorizationPermissionStatus.None; }
        if (states[4] === 1 && state === 0) { states[4] = EAuthorizationPermissionStatus.None; }
        break;
      case EAuthorizationPermissionType.Modify:
        states[2] = state;
        if (state === EAuthorizationPermissionStatus.Deny && states[1] === EAuthorizationPermissionStatus.Allow) {
          states[1] = EAuthorizationPermissionStatus.None;
        }
        if (state === EAuthorizationPermissionStatus.Allow) {
          states[1] = EAuthorizationPermissionStatus.Allow;
        }
        break;
      case EAuthorizationPermissionType.Create:
        states[3] = state;
        if (state === EAuthorizationPermissionStatus.Deny && states[1] !== EAuthorizationPermissionStatus.Deny) {
          states[1] = EAuthorizationPermissionStatus.None;
        }
        if (state === EAuthorizationPermissionStatus.Allow) {
          states[1] = EAuthorizationPermissionStatus.Allow;
        }
        break;
      case EAuthorizationPermissionType.Delete:
        states[4] = state;
        if (state === 1) {
          states[1] = state;
        }
        break;
    }

    this._setStatusControl(states);
  }

  private _setStatusControl(states: number[]) {
    _.forEach(this.dataPermissions, (selectedItemPermission, index) => {
      selectedItemPermission.access = states[index];
      selectedItemPermission.statusAllow = states[index] === 1;
      selectedItemPermission.statusDeny = states[index] === 0;
    });

    _.forEach(this.detailData.Items, (each) => {
      let i = 0;

      if (each.AuthorizationGroup != null && this.selectedConditions[each.AuthorizationGroup.Id]) {
        _.forEach(each.Permissions, (eachP) => {
          eachP.Access = states[i];
          i++;
        });
      }

      if (each.AuthorizationRole != null && this.selectedConditions[each.AuthorizationRole.Id]) {
        _.forEach(each.Permissions, (eachP) => {
          eachP.Access = states[i];
          i++;
        });
      }

      if (each.AuthorizationStakeholder != null && this.selectedConditions[each.AuthorizationStakeholder.Id]) {
        _.forEach(each.Permissions, (eachP) => {
          eachP.Access = states[i];
          i++;
        });
      }
    });
  }

  private _changeStatusNormal(type: any, state: number) {
    _.forEach(this.detailData.Items, (each) => {
      if (each.AuthorizationGroup != null && this.selectedConditions[each.AuthorizationGroup.Id]) {
        const result: any = _.find(each.Permissions, { Type: type });
        result.Access = state;

      }

      if (each.AuthorizationRole != null && this.selectedConditions[each.AuthorizationRole.Id]) {
        const result: any = _.find(each.Permissions, { Type: type });
        result.Access = state;

      }

      if (each.AuthorizationStakeholder != null && this.selectedConditions[each.AuthorizationStakeholder.Id]) {
        const result: any = _.find(each.Permissions, { Type: type });
        result.Access = state;

      }
    });
  }

  isThereAnyPendingChange() {
    return !(_.isEqual(this.initialDetailData, this.detailData));
  }

  public save() {
    this.showAddCondition = false;
    this.isLoadingData = true;
    this.detailData.ParentId = this.nodeId;

    this.authServices.putDataDetail(this.authorizationType, this.nodeId, this.detailData)
      .subscribe((response) => {
        if (response.save) {
          this._translateService.get('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY').subscribe((message: string) => {
            this._toastService.open(
              message,
              {
                  type: 'success',
                  duration: 5000,
                  verticalPosition: 'top',
                  horizontalPosition: 'right'
              });
          });
        }

        this.isLoadingData = false;
                this.unselectable();
                this._setSelectedItemsLength();
    this.resetSeleccionsToAdd();
        this.saveResponse$.next(true);
      }, (error) => {
        this.isLoadingData = false;
        this.showAddCondition = false;
        this._translateService.get('GLOBAL.AN_ERROR_HAS_OCCURRED').subscribe((message: string) => {
          this._toastService.open(
            message,
            {
                type: 'error',
                duration: 0,
                verticalPosition: 'top',
                horizontalPosition: 'right'
            });
        });
        this.saveResponse$.next(false);
      });
    this.initialDetailData = this.detailData;
    return this.saveResponse$;
  }

  public cancelChanges() {
    this.onCancelChanges.emit(true);
  }
  unselectable() {
    this.selectedConditions = {};
  }


  public resetSeleccionsToAdd () {
    this.selectedConditionsToAdd[EAuthorizationItemType.UserGroup] = {};
    this.selectedConditionsToAdd[EAuthorizationItemType.Role] = {};
    this.selectedConditionsToAdd[EAuthorizationItemType.Stakeholder] = {};
  }

  public removeItems() {
    _.remove(this.detailData.Items, item => {
      const authorizationItem = item.AuthorizationGroup || item.AuthorizationRole || item.AuthorizationStakeholder;
      return this.selectedConditions[authorizationItem.Id];
    })

    this.dataPermissions = [];
    this.showDataDetail();
    this.save();
  }

  public clearConditions() {
    this.resetSeleccionsToAdd();
  }
  public openAddConditionMenu () {
    this.resetSeleccionsToAdd();
    this.showAddCondition = true;
    this.showAdvanceOptions(EAuthorizationItemType.UserGroup);
  }

  private _filterConditions(type: EAuthorizationItemType) {
    return (_.filter(this.parameters[type],
      (parameter: IAuthorizationStakeholder) => {
        return !JSON.stringify(this.detailData.Items).match(parameter.id);
      }) as Array<IAuthorizationStakeholder>);
  }
  public applyConditions() {
    const permissions = this._loadPermissions();
    _.forEach(_.values(this.selectedConditionsToAdd[EAuthorizationItemType.UserGroup]), (userGroup: IAuthorizationUserGroup) => {
      const item: any = {
        'Type': 0,
        'AuthorizationGroup': { Id: userGroup.id },
        'AuthorizationRole': null,
        'AuthorizationStakeholder': null,
        'Permissions': permissions
      };
      this.detailData.Items.push(item);
    });
    _.forEach(_.values(this.selectedConditionsToAdd[EAuthorizationItemType.Role]), (role: IAuthorizationRole) => {
      const item: any = {
        'Type': 1,
        'AuthorizationGroup':  null,
        'AuthorizationRole': { Id: role.id },
        'AuthorizationStakeholder': null,
        'Permissions': permissions
      };
      this.detailData.Items.push(item);
    });
    _.forEach(_.values(this.selectedConditionsToAdd[EAuthorizationItemType.Stakeholder]), (stakeholder: IAuthorizationStakeholder) => {
      const item: any = {
        'Type': 2,
        'AuthorizationGroup':  null,
        'AuthorizationRole': null,
        'AuthorizationStakeholder': { Id: stakeholder.id },
        'Permissions': permissions
      };
      this.detailData.Items.push(item);
    });

    this.showDataDetail();
    this.save();
  }

  public toggleAddCondition(condition: IAuthorizationCondition, add: boolean) {
    if(add) {
      this.selectedConditionsToAdd[this.selectedFilterOption][condition.id] = condition;
    } else {
      delete this.selectedConditionsToAdd[this.selectedFilterOption][condition.id];
    }
  }

  public _setSelectedItemsLength() {
    const selectedItemsArray = _.keys(this.selectedConditions);
    this.selectedItemsLength = selectedItemsArray ? selectedItemsArray.length : 0;
    if(this.selectedItemsLength > 1) {
      this.isMultipleSelectionEnabled = false;
    }
  }

  public enableMultipleSelection() {
    _.forEach(this.dataPermissions, permission => {
      permission.statusAllow = false;
      permission.statusDeny = false;
    });
    this.isMultipleSelectionEnabled = true
  }
}
